/* eslint-disable no-param-reassign */
/* eslint-disable react/state-in-constructor */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-undef */
import PropTypes from 'prop-types';
import React from 'react';
import Slide from '../Slide';
import './style.css';

class Slideshow extends React.Component {
  state = {
    currentIndex: 0,
    percent: 100 / this.props.slides.length,
    container: '',
    sliderAutoplay: '',
  };

  componentDidMount() {
    const sliderAutoplay = setInterval(this.next, 10000);
    this.setState({ sliderAutoplay });
  }

  componentWillUnmount() {
    const { sliderAutoplay } = this.state;
    clearInterval(sliderAutoplay);
  }

  slideTo = (index) => {
    const { slides } = this.props;
    const { percent } = this.state;
    index = index < 0 ? slides.length - 1 : index >= slides.length ? 0 : index;
    this.setState({
      container: `translate(-${index * percent}%, 0)`,
    });
    this.setState({ currentIndex: index });
  };

  next = () => {
    const { currentIndex } = this.state;
    this.slideTo(currentIndex + 1);
  };

  render() {
    const { container, percent, currentIndex } = this.state;
    const { slides } = this.props;

    return (
      <div className="slideshow">
        <div
          className="slideshow-container"
          style={{
            transform: `${container}`,
            width: `${slides.length * 100}%`,
          }}
        >
          {slides.map((item, index) => (
            <Slide
              opacity={index === currentIndex ? '1' : '0.6'}
              width={percent}
              key={item}
              image={item}
            />
          ))}
        </div>
      </div>
    );
  }
}

Slideshow.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Slideshow;
